const TableIds = {
    ADMINS: 'adminsTable',
    CLIENTS: 'clientsTable',
    CLIENT_LOGS: 'clientLogsTable',
    COMPANIES: 'companiesTable',
    USERS: 'usersTable',
    CALCULATIONS: 'calculationsTable',
    CALCULATION_LOGS: 'calculationLogsTable',
    DOCUMENTS: 'documentsTable',
    NOTIFICATIONS: 'notificationsTable'
};
export default TableIds;
